import { render, staticRenderFns } from "./AlumnoPerfil.vue?vue&type=template&id=670cb9fd"
import script from "./AlumnoPerfil.vue?vue&type=script&lang=js"
export * from "./AlumnoPerfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports